export const enabledModulesAccess = (modules: string[]) => {
  const env = (window as any).env ?? process.env;

  if (
    env?.REACT_APP_MODULOS === "" ||
    env?.REACT_APP_MODULOS === null ||
    env?.REACT_APP_MODULOS === undefined
  ) {
    return false;
  }

  const modulesAccess = env?.REACT_APP_MODULOS?.split(",") || [];

  for (const module of modules) {
    if (modulesAccess.includes(module)) {
      return true;
    }
  }
  return false;
};

export const hasModuluesAccess = () => {
  const env = (window as any).env ?? process.env;

  if (
    env?.REACT_APP_MODULOS === "" ||
    env?.REACT_APP_MODULOS === null ||
    env?.REACT_APP_MODULOS === undefined
  ) {
    return false;
  }

  const modulesAccess = env.REACT_APP_MODULOS?.split(",") || [];

  return modulesAccess && modulesAccess.length > 0;
};
